const { camelizeKeys } = require('xcase');

export function camelizeRecursive(object) {
  return camelizeKeys(object);
}
